import React, { useState } from 'react';
import useHRCopy from '../hr/i18n/useHRCopy';

export default function SkillsInput({ value = [], onChange }) {
  const t = useHRCopy().candidate.skills;
  const [inputValue, setInputValue] = useState('');

  const handleKeyDown = (e) => {
    if (e.key === ',' || e.key === 'Enter') {
      e.preventDefault();
      const trimmed = inputValue.trim();
      if (trimmed && !value.includes(trimmed)) {
        onChange([...value, trimmed]); // add new skill
      }
      setInputValue('');
    }
  };

  const handleDelete = (skillToRemove) => {
    onChange(value.filter((skill) => skill !== skillToRemove));
  };

  return (
    <div>
      <label className="block mb-2 font-medium text-gray-700">{t.label}</label>

      <div className="flex flex-wrap gap-2 p-2 border border-gray-300 rounded-lg bg-white focus-within:ring-2 focus-within:ring-blue-500">
        {value.map((skill, idx) => (
          <div
            key={idx}
            className="flex items-center bg-blue-100 text-blue-800 text-sm font-medium px-2 py-1 rounded-full"
          >
            {skill}
            <button
              type="button"
              onClick={() => handleDelete(skill)}
              className="ml-2 text-blue-600 hover:text-red-600 font-bold"
            >
              ✕
            </button>
          </div>
        ))}

        <input
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          aria-label={t.label}
          placeholder={value.length === 0 ? t.placeholder : ''}
          className="flex-grow outline-none p-1 text-sm"
        />
      </div>
      <p className="mt-1 text-xs text-gray-500">{t.hint}</p>
    </div>
  );
}
